import React from "react";
import { Form } from "antd";
import Scrollbar from "../../tools/common/Scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { DEFAULT_PROPERTIES_DEFINITION } from "./DefaultPropertiesDefinition";

export const ToolPropertiesPanel = ({ selectedTool }) => {
  const dispatch = useDispatch();
  const properties = useSelector((state) => state.properties);

  const defaultProperty = DEFAULT_PROPERTIES_DEFINITION[selectedTool];

  if (!defaultProperty) {
    console.warn("No tool for:", selectedTool);
    return null;
  }

  const Component = defaultProperty.component;
  const props = defaultProperty.props ? defaultProperty.props(properties, dispatch) : {};

  return (
    <Scrollbar>
      <Form layout="horizontal" colon={false} key={selectedTool}>
        <ul className="rde-ul">
          <li className="rde-ul__li">

            <h3 className="text-center">{defaultProperty.title}</h3>

            <Component
              {...props}
            />

          </li>
        </ul>
      </Form>
    </Scrollbar>
  );
};